<template>
  <!-- 需求-发布需求 -->
  <div class="releaseDemandWrap">
        <div class="tabbox">
            <span :class="index == isOne ? 'on' : ''" v-for="(item,index) in oneList" @click="chooseOne(index,item.code)"><i></i>{{item.value}}</span>
            <!-- <span :class="index == isOne ? 'on' : ''" v-for="(item,index) in 15" @click="chooseOne(index,item.code)"><i></i>测试</span> -->
        </div>
        <div class="tabcontent clearfix" v-if="twoList.length!=0">
            <span :class="index == isTwo ? 'on' : ''" v-for="(item,index) in twoList" @click="chooseTwo(index,item.code)"><i></i>{{item.value}}</span>
            <!-- <span v-for="item in 15">测试数据</span> -->
        </div>
        <mt-field label="需求标题" placeholder="最多输入30字" v-model="fromdata.demandTitle"></mt-field>
        <mt-field label="需求描述"  v-model="fromdata.demandExplain" placeholder="具体描述你想要什么，能尽快找到合适你的服务商，例如：公司背景，需求背景，工作周期等。" type="textarea" rows="4"
        ></mt-field>
        <!-- <div class="demo-upload-list" v-for="item in uploadList">
            <template v-if="item.status === 'finished'">
                <img :src="item.url">
                <div class="demo-upload-list-cover" @click="handleRemove(item)"></div>
            </template>
            <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
        </div> 
        <Upload
            ref="upload"
            v-show="uploadflag"
            name="file"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :data="{'type':2}"
            :max-size="2048"
            multiple
            type="drag"
            :headers="{'Authorization':'bearer'}"
            :action="url+'/image/full/path/upload'">
            <div class="uploaddiv">
                <Icon type="camera" size="20"></Icon>
            </div>
        </Upload>-->
        <div class="zpbgbox clearfix">
            <div class="demo-upload-list" v-if="imageurl">
                <img :src="imageurl" alt="上传好后的图片">
                <div class="demo-upload-list-cover" @click="handleRemove"></div>
            </div>
            
            <div class="zpbg">
                <input type="file" @change="upload" accept="image/*" class="inputfileClass">
            </div>
        </div>        
        <a data-v-095ef35c="" class="mint-cell mint-field">
            <div class="mint-cell-left"></div> 
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                   <span class="mint-cell-text">价格区间</span>
                </div> 
                <div class="mint-cell-value">
                    <input placeholder="" type="number" pattern="[0-9]*"  v-model="fromdata.minPrice"  class="mint-field-core">
                    <span class="mint-field-core">至</span>
                    <input placeholder="" type="number"  pattern="[0-9]*" v-model="fromdata.maxPrice" class="mint-field-core"> 
                </div>
            </div> 
            <div class="mint-cell-right"></div>
        </a>
        <div class="divLine"></div>
        <mt-field label="您的姓名" placeholder="请留下姓名" v-model="fromdata.demandName"></mt-field>
        <div class="divLine"></div>
        <mt-field label="联系方式" type="num" v-model="fromdata.demandMobile" placeholder="留下手机号方便我们找到你"></mt-field>
        <div class="divLine"></div>
        <mt-field label="企业名称" v-model="fromdata.companyName" placeholder="请输入完整的企业名称"></mt-field>
        <div class="divLine"></div>
        <a data-v-095ef35c="" class="mint-cell mint-field"> 
            <div class="mint-cell-left"></div> 
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                     <span class="mint-cell-text">所在区域</span>
                </div> 
                <div class="mint-cell-value">
                    <p v-text="this.regioncityarea" @click="showregioncityareaFN" class="mint-field-core" style="min-height:20px"></p>
                </div> 
            </div> 
            <div class="mint-cell-right"></div>
        </a>
        <mt-popup v-model="popupVisible" position="bottom" :closeOnClickModal="false">
            <span class="closepopup" @click="popupVisibleFlase">关闭</span>
            <mt-picker :slots="slots" value-key="value" @change="onValuesChange"></mt-picker>
        </mt-popup>
        <div>
        <div class="sendDIv">
            <p class="btnsubmit" @click="submitFn">提交</p>
        </div>       
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import global from "../js/global.js"
export default {
  data () {
    return {
        fromdata:{
            area:"",
            city:"",
            companyName:"",
            demandExplain:"",
            demandMobile:"",
            demandName:"",
            demandTitle:"",
            demandType:"",
            imagesURL:[],
            maxPrice:"",
            minPrice:"",
            region:"",
            demandType:"",
        },
        regioncityarea:"",
        url:global.url,
        popupVisible:false,
        slots: [
            {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
            }, {
            flex: 1,
            values: [],
            className: 'slot2',
            textAlign: 'center'
            }, {
            flex: 1,
            values: [],
            className: 'slot3',
            textAlign: 'center'
            }
        ],
        imgName: '',
        visible: false,
        //uploadList: [],
        addcity:[],
        oneList:[],
        isOne:0,
        twoList:[],
        isTwo:0,
        chooseCode:'',
        secondaryDemandType:"",
        token:"",
        imageFile:"",
        imageurl:""
    }
  },
  watch:{
  },
  created(){
  },
  components: {
  },
  mounted(){
    window.getToken = this.getToken;
    if(global.getmobiletype()=="android"){
        this.token = control.getToken(); 
        this.init();
    }
    else{
        window.webkit.messageHandlers.getToken.postMessage({"mothedName":"getToken"});
    }
  },
  methods:{
    getToken(token){
      this.token = token;
      this.init();
    },
    upload(e){
        this.imageFile=e.target.files[0];
        var reader = new FileReader();
        var this_=this;
        reader.onload = (function (file) {
            return function (e) {
                this_.imageurl=this.result; //这个就是base64的数据了
            };
        })(e.target.files[0]);
        reader.readAsDataURL(e.target.files[0]);               
    },
    init(){
        // this.$http.get("system/masterData/three/list/query?type=16",{headers:{"Authorization":"bearer d47391b33e7158eaed88d43d1f125221"}})
        this.$http.get("system/masterData/three/list/query?type=16",{headers:{"Authorization":"bearer "+this.token+""}})
        .then((response) => {
            this.oneList = response.respData.resultData
            this.twoList = this.oneList[0].threeList
            this.chooseCode = this.oneList[0].code;
            this.secondaryDemandType = this.oneList[0].threeList.length==0?'':this.oneList[0].threeList[0].code;
        });
        this.$http.get("/system/get/all/province/to/area/unified/structure")
        .then((response) => {
            this.addcity=response.respData;
        });
    },
    chooseOne(index,code){
        this.isOne = index;
        this.twoList = this.oneList[index].threeList     
        this.chooseCode =code;
        this.secondaryDemandType = this.oneList[index].threeList.length==0?'':this.oneList[index].threeList[0].code;
    },
    chooseTwo(index,code){
        this.isTwo = index;
        this.secondaryDemandType = code
    },
    submitFn(){
        if(this.fromdata.demandTitle==""){
            this.$toast("需求标题不能为空");
            return;
        }
        else if(this.fromdata.demandExplain==""){
            this.$toast("需求描述不能为空");
            return;
        }
        else if(this.fromdata.minPrice==""||this.fromdata.maxPrice=="" || (/\D/g.test(this.fromdata.minPrice)) || (/\D/g.test(this.fromdata.maxPrice)) ){
            this.$toast("请输入正确的价格");
            return;
        }
        else if(this.fromdata.demandName==""){
            this.$toast("您的姓名不能为空");
            return;
        }
        else if(this.fromdata.demandMobile=="") {
                this.$toast('请输入您的手机号');
                return;
            } else if(this.fromdata.demandMobile.length != "11"){
                this.$toast('请输入11位手机号');
                return;	
            }else if(!(/^1[3|4|5|7|8]\d{9}$/.test(this.fromdata.demandMobile))){
                this.$toast('请输入正确的手机号');
                return;
            }
        else if(this.fromdata.companyName==""){
            this.$toast("企业名称不能为空");
            return;
        }
        else if(this.fromdata.region==""){
            this.$toast("省市区不能为空");
            return;
        }
        Indicator.open();
        // this.$http.post("/content/app/demand/add"+global.buildParams(this.fromdata),"",{headers:{"Authorization":"bearer d47391b33e7158eaed88d43d1f125221"}})
        let param = new FormData()  // 创建form对象
        //param.append('imageFile', this.imageFile, this.imageFile.name)  // 通过append向form对象添加数据
        this.imageFile ? param.append('imageFile', this.imageFile, this.imageFile.name) : ""
        param.append('area', this.fromdata.area)
        param.append('city', this.fromdata.city)
        param.append('companyName', this.fromdata.companyName)
        param.append('demandExplain', this.fromdata.demandExplain)
        param.append('demandMobile', this.fromdata.demandMobile)
        param.append('demandName', this.fromdata.demandName)
        param.append('demandTitle',this.fromdata.demandTitle)
        param.append('demandType',this.chooseCode)
        param.append('secondaryDemandType',this.secondaryDemandType)
        param.append('imagesURL', this.fromdata.imagesURL)
        param.append('maxPrice',this.fromdata.maxPrice)
        param.append('minPrice',this.fromdata.minPrice)
        param.append('region',this.fromdata.region)
        let config = {
            headers: {'Content-Type': 'multipart/form-data',"Authorization":"bearer "+this.token+""}
        }       
        this.$http.post("/content/app/demand/add",param,config)
        .then((response) => {
            Indicator.close();
            if(response.dataCode!=1){
                this.$toast(response.respMsg);
            }
            //后台返回demandId，accountId URL上取。
            if(global.getmobiletype()=="android"){
                control.refreshPageWithShare(
                    global.ipHeader+"/needInfo?contentId="+response.respData+"&accountId="+this.$route.query.accountId,
                    "需求详情",
                    response.respData,
                    2,                   
                )
            }
            else{
                window.webkit.messageHandlers.reloadRequirementTypeVCWithDemandType.postMessage(
                   { 
                        "demandType":this.chooseCode,
                        "resolvedType":"1"
                   }
                );
                window.webkit.messageHandlers.refreshNewWebView.postMessage(
                    {
                        "url":global.ipHeader+"/needInfo?contentId="+response.respData+"&accountId="+this.$route.query.accountId,
                        "webTitle":"需求详情",
                        'contentId':response.respData,
                        'dataType':'2',
                        "mothedNameArr":["getToken"]
                    }
                );
            }
        });
    },
    onValuesChange(picker, values) {
        //picker.setValues([this.addcity[0],address[0].childs[0],address[0].childs[0].childs[0]])
        if(!values[0]){
            return;
        }
        else{
            picker.setSlotValues(1, values[0].cityList);
            let town = [];
            if(values[1]){
                town = values[1].areaList;
            }
            picker.setSlotValues(2,town);
        }
        this.$nextTick(()=>{
            this.fromdata.region=values[0].key;
            this.fromdata.city=values[1]?values[1].key:'';
            this.fromdata.area=values[2]?values[2].key:'';
            this.regioncityarea=(values[0]?values[0].value:'')+(values[1]?values[1].value:'')+(values[2]?values[2].value:'')
        })     
    },
    popupVisibleFlase(){
        this.popupVisible=false;
        document.body.addEventListener('touchmove', function (e) {
            e.returnValue = true;
        }, {passive: false});
    },
    showregioncityareaFN(){
        this.popupVisible=true;
        document.body.addEventListener('touchmove', function (e) {
            e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
        }, {passive: false});
        // this.$http.get("/content/industry/activity/activityDetail?activityId="+"5aa63829f5f2ab000171ed9b"+"&accountId=32") this.$route.query.contentId
        this.slots[0].values=this.addcity;
        this.slots[1].values=this.addcity[0].cityList;
        this.slots[2].values=this.addcity[0].cityList[0].areaList;
    },
    clickFabulous(){

    },
    handleRemove (file) {
        this.imageurl="";
    },
    // handleSuccess (res, file) {
    //     this.uploadflag=false;
    //     file.url = file.response.respData;
    //     //file.name = '7eb99afb9d5f317c912f08b5212fd69a';
    // },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.releaseDemandWrap{
    textarea{
        resize:none;
    }
    .mint-cell-wrapper{
        background-image:none;
    }
}
</style>

<style scoped lang="less">
    .releaseDemandWrap{
        color: #333440;
        
        .divLine{
            height: 20px;
            background:#FBF6F6;
        }
        a{
            color: #333440;
            text-decoration: none!important;
        }
        a:hover{
            color:inherit;
        }
        a:focus,.mint-cell-text{
            text-decoration: none!important;
        }
        background: #FBF6F6;
        .tabcontent{
            margin:18px 0;
            overflow-x: auto;
            overflow-y: hidden;
            width: 100%;
            color: #5B5C66;
            background: #fff;
            padding: 10px 0;
            span{
                float: left;
                font-size: 26px;
                margin-left: 18px;
                line-height: 60px;
            }
            .on{
                color:#EF4B4B;
            }
        }
        .tabbox{
            width: auto;
            height: 80px;
            // display: flex;
            text-align: center;
            font-size: 28px;
            color:  #5B5C66;
            background: #fff;
            height: 80px;
            line-height: 80px;
            overflow-x: auto;
            overflow-y: hidden;
            white-space: nowrap;
            -webkit-overflow-scrolling:touch;
            overflow-scrolling:touch;
            span.on{
                color: #EF4B4B;
                position: relative;
                i{
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 4px;
                    bottom: 0;
                    left: 0%;
                    // margin-left:-50%;
                    background: #EF4B4B;
                }
            }
            span{
                display: inline-block;
                line-height:80px;
                padding:0 10px;
                // flex: 1;
                overflow: hidden;
            }
            
        }
    }
    .demo-upload-list{
        float: left;
        width: 160px;
        height: 160px;
        text-align: center;
        line-height: 160px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
    }
    .zpbgbox{
        background:#fff;
        
    }
    .zpbg{
        float: left;
        width:168px;
        height: 168px;
        background: url('../images/zpbg.png') no-repeat;
        background-size:100% 100%;
        position: relative;
        .inputfileClass{
            position: absolute;
            top:0;
            left: 0;
            overflow: hidden;
            width:168px;
            height: 168px;
            opacity: 0;
        }
    }
    .demo-upload-list-cover{
        position: absolute;
        width: 30px;
        height: 30px;
        top: -0px;
        right: -0px;
        background: url('../images/delete@2x.png') no-repeat;
        background-size:100% 100%;
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size:80px;
        cursor: pointer;
        margin: 0 2px;
        vertical-align: middle;
    }
    .uploaddiv{
        width:160px;
        height:160px;
        line-height:160px;
        display: inline-block;

        i{
            font-size:80px!important;
            vertical-align: middle;
        }
    }
    .sendDIv{
         width: 100%;
        height: 180px;
        background: #fbf6f6;
        padding: 40px 30px 60px 30px;
        .btnsubmit{
        background-image: linear-gradient(90deg, #EF4B4B 0%, #F7643C 100%);
        box-shadow: 4px 8px 20px 0 rgba(239,75,75,0.27);
        border-radius: 8px;
        line-height: 80px;
        color: #fff;
        font-size: 30px;
        text-align: center;
        }
    }
    
    .ivu-upload{
        display: inline-block;
    }
    .mint-popup-bottom{
        width: 100%;
    }
    .closepopup{
        float: right;
        font-size: 20px;
        margin-right:10px;
        margin-top: 10px;
        padding-bottom:20px;
        color: #EF4B4B 
    }
</style>



// WEBPACK FOOTER //
// src/pages/releasedemand.vue